 <template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card class="pa-2" v-if="showGLList">
        <v-card-title class="grey lighten-2" primary-title>
          GL Transaction List
          <v-spacer></v-spacer>
          <v-btn text icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ glTransDetLabel.journal }}</v-subheader>
                  <span class="title">{{ objData.glJrnl }}</span>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ glTransDetLabel.docNo }}</v-subheader>
                  <span class="title">{{ objData.docNo }}</span>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ glTransDetLabel.acctNo }}</v-subheader>
                  <div class="title" v-for="item in filterAcctNoList" :key="item.label">{{ item.label }}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ glTransDetLabel.tranDate }}</v-subheader>
                  <span class="title">{{ objData.tranDate }}</span>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ glTransDetLabel.acctPeriod }}</v-subheader>
                  <span class="title">{{ objData.acctPeriod }}</span>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ glTransDetLabel.polOrClm }}</v-subheader>
                  <span class="title">{{ objData.polOrClm }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex xs12 class="mt-3">
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs12>
            <v-flex xs12>
              <v-card>
                <v-data-table
                  v-bind:headers="glTranColumns"
                  v-bind:items="itemsGL"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  item-key="key"
                  :loading="loading"
                  :no-data-text="noDataText"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectedGLTranColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action :rowData="row" query @query="doGLQuery(row)"></table-action>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
      <div v-if="showGLDetail">
        <g-l-trans-detail :objData="glObjData" @close=";(showGLDetail = false), (showGLList = true)"/>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { accountsViewMixin } from '@/mixins/accounting/accountsViewMixin'
import GLTransDetail from './GLTransDetail.vue'

export default {
  data() {
    return {
      showGLList: true,
      showGLDetail: false,
      glTransDetLabel: {
        journal: 'Journal',
        itemNo: 'Item No.',
        glAcctNo: 'GL Account No.',
        gstStatRate: 'GST Status, Rate',
        gstAmt: 'GST Amount',
        origCurrAmt: 'Original Currency Amount',
        locAmt: 'Local Amount',
        transDate: 'Transaction Date',
        acctPeriod: 'Accounting Period',
        glInterface: 'GL Interface',
        batchNo: 'Batch No.',
        reversalStat: 'Reversal Status',
        createdBy: 'Created By',
        modifiedBy: 'Modified By',
        docBrn: 'Branch',
        docFund: 'Fund',
        docNo: 'Document No.',
        docAcctSfx: 'Account No. Suffix',
        acctNo: 'Account No.',
        rbcAcctNo: 'RBC Account No.',
        polNo: 'Policy No.',
        clmNo: 'Claim No',
        comDate: 'Commencement Date',
        expDate: 'Expiry Date',
        holdGLUpd: 'Hold GL Update',
        glAc1: 'Code 1',
        glAc2: 'Code 2',
        glAc3: 'Code 3',
        glAc4: 'Code 4',
        glAc5: 'Code 5',
        glAc6: 'Code 6',
        glAc7: 'Code 7',
        glAc8: 'Code 8',
        glAc9: 'Code 9',
        glAc10: 'Code 10',
        tranDate: 'Transaction Date',
        polOrClm: 'Policy or Claim',
        project: 'Project',
        glDept: 'GL Department'
      },
      paginationGLTran: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      selectedGLTranColumns: ['glAcctNo', 'desc', 'curr', 'amt', 'locAmt', 'batchNo', 'riPanel'],
      glTranColm: [
        { text: 'GL Account No.', value: 'glAcctNo' },
        { text: 'Description', value: 'desc' },
        { text: 'Currency', value: 'curr' },
        { text: 'Amount', value: 'amt' },
        { text: 'Local Amount', value: 'locAmt' },
        { text: 'Batch No. ', value: 'batchNo' },
        { text: 'RI Panel', value: 'riPanel' }
      ],
      glObjData: {
        glJrnl: undefined,
        glItemNo: undefined
      },
      accountnos: []
    }
  },
  mounted() {
    this.fetchAccount()
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    doGLQuery(data) {
      this.showGLList = false
      this.showGLDetail = true
      this.glObjData.glJrnl = data.item.journal
      this.glObjData.glItemNo = data.item.itemNo
    },
    chkGlSys() {
      if (this.glTransDet.glSys === 2) {
        return false
      } else {
        return true
      }
    }
  },
  computed: {
    glTranColumns() {
      let result = []
      for (const selectedGLTranColumns of this.selectedGLTranColumns) {
        let findCol = this.glTranColm.find((a) => selectedGLTranColumns === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    filterAcctNoList() {
      return this.accountnos.filter((list) => {
        return list.value === this.objData.acctNo
      })
    }
  },
  props: {
    itemsGL: {
      type: Array,
      default: null
    },
    objData: {
      type: Object,
      default: null
    }
  },
  components: { GLTransDetail },
  mixins: [TableConst.default, accountsAjaxCalls, accountsFilters, accountsViewMixin]
}
</script>
